import { Route } from '@/app/router'
import TasksEnabled from '@/middleware/TasksEnabled'
import QuantityDisabled from '@/middleware/QuantityDisabled'
const Tasks = () => import('./index.vue')

const TasksMeta = {
	sort: 8,
	displayInSidebar: true,
	displayName: 'task',
	icon: 'fal file-check',
	activeIcon: 'fas file-check'
	// icon: 'fal tasks',
	// activeIcon: 'fas tasks'
}

const TasksProps = ['page', 'perPage']

export default new Route('/tasks', Tasks)
	.as('Dashboard:Tasks')
	.meta(TasksMeta)
	.props(TasksProps)
	.permissions(['TASK_FLOW_ENABLED', 'PARTS_QUANTITY_DISABLED', 'VIEW_TASK'])
	.middlewares([TasksEnabled, QuantityDisabled])
